export function getPathnameByUrl(url) {
  const cleanedUrl = url?.startsWith("/") ? url?.slice(1) : url;
  const segments = cleanedUrl?.split("/");
  return [segments?.[0], segments?.[1], segments?.[2]];
}

export const UserPermissionRoutes = {
  "patient-transaction": "transaction-management",
  "withdrawal-requests": "transaction-management",
  commission: "transaction-management",
  "delivery-settings": "transaction-management",
  "category-management": "category-management",
  chat: "chats-and-dispute-management",
  "slider-ad": "ads-management",
  "banner-ad": "ads-management",
};

export const specialCaseRoutes = {
  "user-management": [
    "doctors-management",
    "pharmacy-management",
    "patients-management",
    "shopkeeper-management",
    "sub-admin-management",
  ],
};
export const UserManagementPermissions = {
  "user-management": [
    "doctors-management",
    "pharmacy-management",
    "patients-management",
    "shopkeeper-management",
    "sub-admin-management",
  ],
};
export const notProtectedRoutes = ["profile-settings", "notifications", ""];

export const subPermissionRoutes = {
  view: "view",
  update: "update",
  create: "create",
};
export const multiPermissionRoutes = ["reports"];
export const filterSideBarLinks = (links, permissionsArr) => {
  const routeLinks = [];
  for (let i = 0; i < links?.length; i++) {
    const link = links[i];

    if (link?.subMenu?.length > 0) {
      const updatedSubLinks = [];
      const subMenu = link?.subMenu;
      for (let j = 0; j < subMenu.length; j++) {
        const subLink = subMenu[j];
        const [roleByPath] = getPathnameByUrl(subLink?.path);
        const permission = permissionsArr?.find(
          (perm) =>
            perm?.main === UserPermissionRoutes[roleByPath] ||
            specialCaseRoutes[roleByPath]?.includes(perm?.main)
        );
        if (!permission) continue;

        updatedSubLinks.push(subLink);
      }
      if (updatedSubLinks.length > 0) {
        routeLinks.push({ ...link, subMenu: updatedSubLinks });
      }
      continue;
    }
    const [roleByPath] = getPathnameByUrl(link?.path);

    if (notProtectedRoutes?.includes(roleByPath)) {
      routeLinks.push(link);
    }

    for (let i = 0; i < permissionsArr?.length; i++) {
      const permission = permissionsArr[i];
      if (permission?.main === UserPermissionRoutes[roleByPath]) {
        routeLinks.push(link);
        break;
      }
      if (
        specialCaseRoutes[roleByPath]?.includes(permission?.main) &&
        !routeLinks?.find((ele) => ele?.path === link?.path)
      ) {
        routeLinks.push(link);
      }
    }
  }
  return routeLinks;
};
export const checkSubPermission = (user, mainPermission, subPermission) => {
  const main = user?.roleGroup?.permissions?.find(
    (ele) => ele?.main === mainPermission
  );
  if (!main) return false;
  return main?.sub?.includes(subPermission);
};
